/** Dependency ids and error details are diagnostics, never stage identifiers. */
export function fromBaseStageIds(values: readonly string[]): string[] {
    return [...new Set(values.map(value => value.replace(/^from-base-stage-missing:/, '').split(':')[0]!))];
}
